const STORAGE_KEY = 'mylo:qld-sa-announcement:last-seen:v2';
const DISMISSED_ATTRIBUTE = 'data-mylo-announcement-dismissed';
const VISIT_TIMEOUT_MS = 30 * 60 * 1000;

export function restoreAnnouncement() {
  try {
    const lastSeen = Number(window.sessionStorage.getItem(STORAGE_KEY));
    const now = Date.now();
    const dismissed = lastSeen > 0
      && now >= lastSeen
      && now - lastSeen < VISIT_TIMEOUT_MS;

    document.documentElement.toggleAttribute(DISMISSED_ATTRIBUTE, dismissed);
    if (dismissed) {
      window.sessionStorage.setItem(STORAGE_KEY, String(now));
    } else {
      window.sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // With storage blocked, retain this document's current dismissal instead.
  }
}

export function rememberAnnouncementVisit() {
  if (!document.documentElement.hasAttribute(DISMISSED_ATTRIBUTE)) return;

  try {
    window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    // Dismissal still works for navigation within the current document.
  }
}

export function dismissAnnouncement() {
  document.documentElement.setAttribute(DISMISSED_ATTRIBUTE, '');
  rememberAnnouncementVisit();
}
